import { SymbolPayoutData } from "@lib/titan2-slingo/dist/api/model/data/SymbolPayoutData";
import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { SymbolType } from "@lib/titan2-slingo/dist/api/model/enum/SymbolType";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
/**
 * ExtendedSymbolPayoutData.ts
 */
export class ExtendedSymbolPayoutData extends SymbolPayoutData {
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            const symbols = this.data.getStringArray(SlingoConstants.PROPERTY_SYMBOLS);
            if (symbols.includes(SlingoStyle.COIN)) {
                this.type = SymbolType.COIN;
            }
            else if (symbols.includes(SlingoStyle.JOKER) || symbols.includes(SlingoStyle.SUPER_JOKER)) {
                this.type = undefined; // scatters are represented by undefined in titan-slingo a lot
            }
            else {
                throw new Error("Invalid payout data");
            }
        }
    }
}
//# sourceMappingURL=ExtendedSymbolPayoutData.js.map